import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: any, option) {
    let options: AbstractControlOptions = {};
    const formConfig = {
      ownerId: [entity?.ownerId],
      productId: [entity?.productId],

      fcpiPeaPmeTitreBankName: [
        entity?.fcpiPeaPmeTitreBankName || null,
        Validators.required,
      ],
      fcpiPeaPmeTitreBankCity: [
        entity?.fcpiPeaPmeTitreBankCity || null,
        Validators.required,
      ],
      fcpiPeaPmeTitreRibBankingCode: [
        entity?.fcpiPeaPmeTitreRibBankingCode || null,
        Validators.required,
      ],
      fcpiPeaPmeTitreRibBranchCode: [
        entity?.fcpiPeaPmeTitreRibBranchCode || null,
        Validators.required,
      ],
      fcpiPeaPmeTitreRibAccountNumber: [
        entity?.fcpiPeaPmeTitreRibAccountNumber || null,
        Validators.required,
      ],
      fcpiPeaPmeTitreRibKey: [
        entity?.fcpiPeaPmeTitreRibKey || null,
        Validators.required,
      ],
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  extract() {
    return this.form.value.products;
  }
}
